import React from 'react'

const TeleConsultSvg = (props: any) => {
  return (
    <svg
      {...props}
      width="29"
      height="28"
      viewBox="0 0 29 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_2101:120399)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M1.42383 6.06934C0.871543 6.06934 0.423828 6.51705 0.423828 7.06934V20.9313C0.423828 21.4835 0.871543 21.9313 1.42383 21.9313H20.0766C20.6289 21.9313 21.0766 21.4835 21.0766 20.9313V17.5637L27.6294 20.913C27.9621 21.083 28.357 20.8414 28.357 20.4678V6.73895C28.357 6.36532 27.9621 6.12369 27.6294 6.29373L21.0766 9.64302V7.06934C21.0766 6.51705 20.6289 6.06934 20.0766 6.06934H1.42383Z"
          fill={props?.fill ?? '#3E4685'}
        />
      </g>
      <defs>
        <clipPath id="clip0_2101:120399">
          <rect
            width="28"
            height="28"
            fill="white"
            transform="translate(0.25)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default TeleConsultSvg
